import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  configPath: 'assets/config.json'
};
